import { TranslationKey } from './../../../../types/translation/TranslationKey';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import TaskSettingsPane from './Panes/TaskSettingsPane';
import TaskExportConfigurationsPane from './Panes/TaskExportConfigurationsPane';
import { t } from '../../../../types/translation/Translator';
import CreateTaskExportConfigurationPane from './Panes/Export/Panes/CreateTaskExportConfigurationPane';
import UpdateTaskExportConfigurationPane from './Panes/Export/Panes/UpdateTaskExportConfigurationPane';
import { Routing } from '../../../../util/routes.util';
import { Breadcrumbs, TaskOverviewCrumb, TaskSettingsCrumb } from '../../../components/Breadcrumbs';
import { Tab, Tabs } from '../../../components/Tabs';

export default function TaskSettingsScreen() {
  return (
    <div className='flex h-full flex-grow flex-col'>
      <Breadcrumbs>
        <TaskOverviewCrumb />
        <TaskSettingsCrumb current />
      </Breadcrumbs>
      <div className='content-y-breadcrumbs flex flex-grow flex-col overflow-hidden'>
        <Tabs padding>
          <Tab
            text={t(TranslationKey.settings).singular.label}
            path={Routing.tasks.settings.overview()}
            key={'settings'}
          />

          <Tab
            text={t(TranslationKey.reporting).singular.label}
            path={Routing.tasks.settings.report.overview()}
            key={'settings/report'}
          />
        </Tabs>
        <div className='flex-grow overflow-hidden'>
          <Routes>
            <Route path='report' element={<TaskExportConfigurationsPane />} />
            <Route path='report/create' element={<CreateTaskExportConfigurationPane />} />
            <Route path='report/update/:id' element={<UpdateTaskExportConfigurationPane />} />

            <Route path='settings' element={<TaskSettingsPane />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
